import { useState } from 'react';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { findNextFreeWindow, type NextFreeWindowView } from '../workshop-bookings.api';

export type NextFreeWindowState =
  { status: 'idle' } | { status: 'searching' } | { status: 'answered'; answer: NextFreeWindowView } | { status: 'error'; message: string };

/** Asks the server for the earliest window of a given length, between the truck's trips and bookings, that ends by a due date. Writes nothing. */
export function useNextFreeWindow(truckId: string) {
  const [state, setState] = useState<NextFreeWindowState>({ status: 'idle' });

  async function search(input: { durationMinutes: number; dueBy: string }): Promise<void> {
    setState({ status: 'searching' });
    try {
      setState({ status: 'answered', answer: await findNextFreeWindow(truckId, input) });
    } catch (err) {
      setState({ status: 'error', message: apiErrorMessage(err) ?? 'Could not look for a window. Try again.' });
    }
  }

  return { state, search, reset: () => setState({ status: 'idle' }) };
}
